import React from 'react'
import { SVGProps } from 'react'

const IconTrash = React.memo<SVGProps<any>>(props => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <defs>
      <path
        id="IconTrash"
        d="M4.197 22.238a1.131 1.131 0 0 1-.1-.1c.036.036.066.072.1.1zm-.224-.128zM22.275 4.768a.885.885 0 0 0-.616-.248h-4.321V3.174c0-.91-.74-1.65-1.65-1.65H8.31c-.91 0-1.65.74-1.65 1.65V4.52H2.318a.839.839 0 0 0 0 1.676h.74v14.587c0 .91.74 1.65 1.65 1.65h14.818c.91 0 1.65-.74 1.65-1.65V6.196h.483c.46 0 .861-.374.861-.838a.825.825 0 0 0-.245-.59zM8.308 3.178h7.372v1.356H8.308V3.18zm11.216 17.603H4.708V6.196h14.815v14.585h.001zM11.988 9.005a.842.842 0 0 0-.842.843v7.819a.842.842 0 1 0 1.685 0v-7.82a.842.842 0 0 0-.843-.842zm-4.564 0a.842.842 0 0 0-.843.843v7.819a.842.842 0 1 0 1.685 0v-7.82a.843.843 0 0 0-.842-.842zm9.083 0a.842.842 0 0 0-.843.843v7.819a.842.842 0 1 0 1.685 0v-7.82a.842.842 0 0 0-.842-.842z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <mask id="b" fill="#fff">
        <use xlinkHref="#IconTrash" />
      </mask>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#IconTrash" />
      <g mask="url(#b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
))

export default React.memo(IconTrash)
